var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2223_7905)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0002 0C4.47702 0 0 4.47702 0 10.0002C0 15.5234 4.47702 20.0004 10.0002 20.0004C15.5234 20.0004 20.0004 15.5234 20.0004 10.0002C19.9936 4.48 15.5204 0.00639209 10.0002 0ZM10.0002 18.1821C5.48143 18.1821 1.81834 14.519 1.81834 10.0002C1.81834 5.48143 5.48143 1.81834 10.0002 1.81834C14.519 1.81834 18.1821 5.48143 18.1821 10.0002C18.1766 14.5169 14.5169 18.1766 10.0002 18.1821Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9092 9.62398V4.54567C10.9092 4.04368 10.5023 3.63672 10.0003 3.63672C9.49827 3.63672 9.09131 4.04368 9.09131 4.54567V10.0003C9.09131 10.2415 9.18719 10.4724 9.35765 10.6429L12.0849 13.3702C12.4459 13.7192 13.0216 13.7089 13.3706 13.348C13.7111 12.9956 13.7111 12.4373 13.3706 12.0849L10.9096 9.62398H10.9092Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2223_7905"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.81815160.svg";
export { ForwardRef as ReactComponent };